export default __webpack_public_path__ + "static/media/speaker.7e1bd615.png";